<div class="container-fluid py-lg-5" id="skill">
    <h2 class="title-skills">Compétences</h2>

    <div class="col-sm-10 offset-sm-1 div-skills">
        <div class="row">
            <!-- First col of skills -->
            <div class="col-sm-6">
                <!-- Symfony -->
                <div class="row">
                    <div class="col-2">
                        <p class="name-skill">Symfony</p>
                    </div>
                    <mat-progress-bar class="col-6 bar-skills" [color]="color" [mode]="mode" [value]="values[0]">
                    </mat-progress-bar>
                    <div class="col-1">
                        <img class=" icon-skills" src="assets/skills/sym.png" />
                    </div>
                </div>
                <!-- Java -->
                <div class="row">
                    <div class="col-2">
                        <p class="name-skill">Java</p>
                    </div>
                    <mat-progress-bar class="col-6 bar-skills" [color]="color" [mode]="mode" [value]="values[0]">
                    </mat-progress-bar>
                    <div class="col-1">
                        <img class="icon-skills" src="assets/skills/java.png" />
                    </div>
                </div>
                <!-- Python -->
                <div class="row">
                    <div class="col-2">
                        <p class="name-skill">Python</p>
                    </div>
                    <mat-progress-bar class="col-6 bar-skills" [color]="color" [mode]="mode" [value]="values[2]">
                    </mat-progress-bar>
                    <div class="col-1">
                        <img class="icon-skills" src="assets/skills/python.png" />
                    </div>
                </div>
                <!-- HTML/CSS -->
                <div class="row">
                    <div class="col-2">
                        <p class="name-skill">HTML/CSS</p>
                    </div>
                    <mat-progress-bar class="col-6 bar-skills" [color]="color" [mode]="mode" [value]="values[3]">
                    </mat-progress-bar>
                    <div class="col-1">
                        <img class="icon-skills" src="assets/skills/html.png" />
                    </div>
                </div>
                <!-- MySql -->
                <div class="row">
                    <div class="col-2">
                        <p class="name-skill">MySql</p>
                    </div>
                    <mat-progress-bar class="col-6 bar-skills" [color]="color" [mode]="mode" [value]="values[5]">
                    </mat-progress-bar>
                    <div class="col-1">
                        <img class="icon-skills" src="assets/skills/mysql.png" />
                    </div>
                </div>
                <!-- Wlangage -->
                <div class="row">
                    <div class="col-2">
                        <p class="name-skill">Wlangage</p>
                    </div>
                    <mat-progress-bar class="col-6 bar-skills" [color]="color" [mode]="mode" [value]="values[4]">
                    </mat-progress-bar>
                    <div class="col-1">
                        <img class="icon-skills" src="assets/skills/w.png" />
                    </div>
                </div>
            </div>
            <!-- Second col of skills-->
            <div class="col-sm-6">
                <!-- Linux -->
                <div class="row">
                    <div class="col-2">
                        <p class="name-skill">Linux</p>
                    </div>
                    <mat-progress-bar class="col-6 bar-skills" [color]="color" [mode]="mode" [value]="values[4]">
                    </mat-progress-bar>
                    <div class="col-1">
                        <img class="icon-skills" src="assets/skills/linux.png" />
                    </div>
                </div>
                <!-- React -->
                <div class="row">
                    <div class="col-2">
                        <p class="name-skill">React</p>
                    </div>
                    <mat-progress-bar class="col-6 bar-skills" [color]="color" [mode]="mode" [value]="values[5]">
                    </mat-progress-bar>
                    <div class="col-1">
                        <img class="icon-skills" src="assets/skills/react.png" />
                    </div>
                </div>
                <!-- Typescript -->
                <div class="row">
                    <div class="col-2">
                        <p class="name-skill">Typescript</p>
                    </div>
                    <mat-progress-bar class="col-6 bar-skills" [color]="color" [mode]="mode" [value]="values[6]">
                    </mat-progress-bar>
                    <div class="col-1">
                        <img class="icon-skills" src="assets/skills/ts.png" />
                    </div>
                </div>
                <!-- Angular -->
                <div class="row">
                    <div class="col-2">
                        <p class="name-skill">Angular</p>
                    </div>
                    <mat-progress-bar class="col-6 bar-skills" [color]="color" [mode]="mode" [value]="values[7]">
                    </mat-progress-bar>
                    <div class="col-1">
                        <img class="icon-skills" src="assets/skills/angular.png" />
                    </div>
                </div>
                <!-- Docker -->
                <div class="row">
                    <div class="col-2">
                        <p class="name-skill">Docker</p>
                    </div>
                    <mat-progress-bar class="col-6 bar-skills" [color]="color" [mode]="mode" [value]="values[7]">
                    </mat-progress-bar>
                    <div class="col-1">
                        <img class="icon-skills" src="assets/skills/docker.png" />
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>